import React from 'react';
import { Trans } from 'react-i18next';
import i18n from 'i18next';
import { css } from '@emotion/core';

import useScrollElementOnMount from 'client/hooks/useScrollElementOnMount';
import Popup from 'client/components/Popup';
import { Typography } from '@material-ui/core';
import { PointSystemPoints } from 'client/components/dialogVerification/dialogDeductPoint/DialogDeductPoint';

export default function DialogPointNotEnough({
    isOpen,
    onClose = () => {},
    points,
    transactionWithdrawQuantity
}) {
    const bindRef = useScrollElementOnMount();

    return (
        <>
            <Popup
                isOpen={isOpen}
                title={i18n.t('label.Insufficient_quantity')}
                onConfirm={onClose}
                endButton={i18n.t('btn.close')}
                disableBackdropClick
            >
                <div css={dialogContentStyle} ref={bindRef}>
                    <Typography variant="subtitle2" css={descStyle}>
                        <Trans
                            i18nKey={i18n.t('label.can_use')}
                            components={<PointSystemPoints pointCount={points} pointSize={20} />}
                        />
                    </Typography>
                    <Typography variant="subtitle2" css={descStyle}>
                        <Trans
                            i18nKey={i18n.t('label.hint.activity.needs')}
                            components={
                                <PointSystemPoints
                                    pointCount={transactionWithdrawQuantity}
                                    pointSize={14}
                                />
                            }
                        />
                    </Typography>
                </div>
            </Popup>
        </>
    );
}

const dialogContentStyle = css`
    padding: 16px;
    text-align: center;
`;

const descStyle = css`
    display: flex;
    justify-content: center;
    align-items: center;
`;
